// extracted by mini-css-extract-plugin
module.exports = {"cardIcon":"card_cardIcon__MJHas","cardTextDiv":"card_cardTextDiv__1R0ku","cardTitle":"card_cardTitle__3yUXa","cardNote":"card_cardNote__Hfeet"};